import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileLoginComponent } from './mobile-login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    MobileLoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    MobileLoginComponent
  ]
})
export class MobileLoginModule { }
